import { render } from "./TrainingAuswahlView.vue?vue&type=template&id=9dd0e5a8&scoped=true"
import script from "./TrainingAuswahlView.vue?vue&type=script&lang=js"
export * from "./TrainingAuswahlView.vue?vue&type=script&lang=js"

import "./TrainingAuswahlView.vue?vue&type=style&index=0&id=9dd0e5a8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9dd0e5a8"]])

export default __exports__